import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReleaseNote } from '../../models/release-note';
import { SUPPRESS_ERROR } from 'src/app/utils/httpContextTokens';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {

  constructor(private http: HttpClient) { }

  latestReleaseNote(url: string, suppressError: boolean = false): Observable<ReleaseNote> {
    const context = new HttpContext().set(SUPPRESS_ERROR, suppressError);
    return this.http.get<ReleaseNote>(url, { context }).pipe(map((result: any) => {
      return {
        id: result.Id,
        title: result.Title,
        summary: result.Summary,
        url: result.URL
      };
    }));
  }
}
